import { IChatEntity } from '../interfaces/chat-entity.interface';
import { IInboxFilter } from '../interfaces/inbox-filter.interface';

export const chatSorter = (
  chatA: IChatEntity,
  chatB: IChatEntity,
  filter: IInboxFilter,
) => {
  const orderBy = filter?.orderBy;

  if (!orderBy) {
    return 0;
  }

  const a = chatA[orderBy.field] as string;
  const b = chatB[orderBy.field] as string;

  switch (orderBy.direction) {
    case 'desc':
      return new Date(a).getTime() - new Date(b).getTime();
    case 'asc':
    default:
      return new Date(b).getTime() - new Date(a).getTime();
  }
};
